export const environment = {
  production: false,
  productName: "Invictus",
  changePersistenceCompatibleCcuVersion: '2.18.0',
  caretakerUrl: "https://caretaker.dev.service.75f.io/api/v1",
  externalServices: "https://external-services.dev.service.75f.io/",
  helpCenter: "https://support.75f.io",
  partnerName: "75F",
  multiregion: false,
  regions: [{
    regionId: "1",
    regionCode: "NA",
  }],
  "1": {
    regionName: "North America",
    siloUrl: "https://silo.carrier.service.75f.io/",
    siteManagerServiceUrl: "https://site-manager.carrier.service.75f.io/"
  }
};
